var $c64a265512dcebd5$exports = {};
$c64a265512dcebd5$exports = {
    "actions": `Dejanja`,
    "actionsAvailable": `Na voljo so dejanja.`,
    "clearSelection": `Po\u{10D}isti izbor`,
    "selected": (args)=>`Izbrano: ${args.count}`,
    "selectedAll": `Vsi izbrani`
};


export {$c64a265512dcebd5$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
